import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const [result, setResult] = useState(null);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const interval = setInterval(async () => {
      attempts++;
      try {
        const { data } = await api.get(`/api/payments/checkout/status/${sessionId}`);
        if (data.payment_status === "paid") {
          clearInterval(interval);
          setStatus("paid"); setResult(data);
        } else if (data.status === "expired" || attempts >= 8) {
          clearInterval(interval);
          setStatus("failed");
        }
      } catch {
        if (attempts >= 8) { clearInterval(interval); setStatus("failed"); }
      }
    }, 2000);
    return () => clearInterval(interval);
  }, [sessionId]);

  return (
    <div className="max-w-xl mx-auto px-6 py-24 text-center" data-testid="payment-success-page">
      {status === "polling" && (
        <>
          <Loader2 className="w-12 h-12 animate-spin mx-auto text-[#D92D20]" />
          <h1 className="font-display font-black text-3xl mt-4">Confirming your payment…</h1>
          <p className="text-[#4B5563] mt-2">This usually takes a few seconds.</p>
        </>
      )}
      {status === "paid" && (
        <>
          <CheckCircle className="w-14 h-14 mx-auto text-[#064E3B]" />
          <h1 className="font-display font-black text-3xl mt-4">Payment successful!</h1>
          <p className="text-[#4B5563] mt-2">You're enrolled. Time to start learning.</p>
          <div className="mt-6 flex gap-3 justify-center">
            <button onClick={() => nav(`/learn/${result.course_id}`)} data-testid="start-learning" className="btn-primary">Start learning</button>
            <button onClick={() => nav("/dashboard")} className="btn-outline">Dashboard</button>
          </div>
        </>
      )}
      {status === "failed" && (
        <>
          <h1 className="font-display font-black text-3xl">We couldn't confirm payment.</h1>
          <p className="text-[#4B5563] mt-2">Please check your email or try again.</p>
          <button onClick={() => nav("/courses")} className="btn-primary mt-6">Back to courses</button>
        </>
      )}
    </div>
  );
}
